var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-balance", attrs: { id: "account-balance" } },
    [
      _c("img", { attrs: { src: "/static/submenu-wallet.svg" } }),
      _vm._v(" "),
      _c("h3", [_vm._v("Confirmar agendamento com o seu saldo?")]),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "warning" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Confirmaremos a sua limpeza utilizando o saldo da sua carteira em alguns instantes!"
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "btn-group" }, [
        _c(
          "button",
          {
            staticClass: "btn bg-purple-outline",
            on: { click: _vm.resetPayment }
          },
          [_vm._v("Não, quero voltar")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn bg-purple", on: { click: _vm.submit } },
          [_vm._v("Sim, confirmar limpeza com o meu saldo")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("hr"),
      _vm._v(" "),
      _c("p", { staticClass: "warning" }, [
        _vm._v(
          "\n      Não será gerada nenhuma cobrança adicional para essa limpeza.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d333f2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d333f2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/PaymentOptions/AccountBalance.vue
// module id = null
// module chunks = 